import React from "react";

const ContainerHome = ({ children }) => {
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">{children}</div>
      </div>
    </>
  );
};

export default ContainerHome;
